import { useCallback } from 'react';

export const useIncludeProjectIdToArguments = (fn, projectId) => {
  return useCallback((...args) => fn(projectId, ...args), [projectId, fn]);
};
